import React, { useContext } from 'react';
import qs from 'qs';

import PresentContainer from '../containers/present/PresentContainer';
import PageTemplate from '../components/common/template/PageTemplate';
import AffiliateContext from '../modules/contexts/AffiliateContext';

const PresentPage = ({ location }) => {
  const query = qs.parse(location.search.substr(1));
  const status = query.imp_success;
  const errorMSG = query.error_msg;
  const imp_uid = query.imp_uid;
  const merchant_uid = query.merchant_uid;

  const affiliateContext = useContext(AffiliateContext);

  return (
    <PageTemplate title="선물하기">
      <PresentContainer
        status={status}
        errorMSG={errorMSG}
        imp_uid={imp_uid}
        merchant_uid={merchant_uid}
        affiliateContext={affiliateContext}
      />
    </PageTemplate>
  );
};

export default PresentPage;
